<ng-container content>
    <ham-page-tab-navigation [navigationItems]="activeNavigationTabs"> </ham-page-tab-navigation>

    <div>
        <router-outlet></router-outlet>
    </div>
</ng-container>
